import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCGHC0fxs-FpjWqCbbR7B8ZjiISASvmTEA",
  authDomain: "smartgroceryapps.firebaseapp.com",
  projectId: "smartgroceryapps",
  storageBucket: "smartgroceryapps.firebasestorage.app",
  messagingSenderId: "172167271617",
  appId: "1:172167271617:web:c6ed84d01313f12d337040",
  measurementId: "G-TPQ3TWM46N"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
